import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES } from '../../config/url.servicio'

@Injectable()
export class EntidadesProvider {

  constructor(public http: Http) {

  }

  buscarEntidadesPorEmpresa(companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarEntidadesPorEmpresa",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarEntidadesPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
    }
  }

  buscarEntidadPorCompania (text, companiaId?: string){
    if(NUBE_AWS) {
      const url_servicio = URL_SERVICIOS_AWS;

      let valuecompaniaId = companiaId
      let data = {
        name: "buscarEntidadPorCompania",
        parameters : {datoBusca: text,companiasId:valuecompaniaId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option

      return this.http.post(`${url_servicio}/procedure`, data, options)
          .map((data: any) =>
           {
             let  dataNew = JSON.parse(data._body).data
             return dataNew[0].map((item, index) => {
                console.log(item)
                return {
                  display: item.nombreEntidad,
                  value: item.entidadesId
              }})});
    } else {
        const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarEntidadPorCompania?datoBusca=${text}&companiasId=${companiaId}`;
        return this.http
            .get(url)
            .map(data => data.json()[0].map(item => {
                return {
                    display: item.nombreEntidad,
                    value: item.entidadesId
                }
            } ));
      }
  }


  buscarConceptosEgresosPorCompania (text, companiaId?: string){
      const url_servicio = URL_SERVICIOS_AWS;

      let valuecompaniaId = companiaId
      let data = {
        name: "buscarConceptosEgresosPorCompania",
        parameters : {datoBusca: text,companiasId:valuecompaniaId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option

      return this.http.post(`${url_servicio}/procedure`, data, options)
          .map((data: any) =>
           {
             let  dataNew = JSON.parse(data._body).data
             return dataNew[0].map((item, index) => {
                console.log(item)
                return {
                  display: item.nombre,
                  value: item.conceptosEgresosId
              }})});

  }

  guardarLogFacturaElectronica(data: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let values = {
        name: data.name,
        parameters : {...data, nombreTabla: data.nombreTabla}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, values, options);
    } else {
        const url = URL_SERVICIOS_LOCALES;
        return this.http.post(`${url}/query`, data);
     }
  }

  buscarFacturasGeneradas(companiasId: any,fechaInicio: any, fechaFinal: any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarFacturasGeneradas",
        parameters : {companiasId:companiasId, fechaInicio:fechaInicio,fechaFinal:fechaFinal }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  guardarLogPosElectronica(data: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let values = {
        name: data.name,
        parameters : {...data, nombreTabla: data.nombreTabla}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, values, options);
    } else {
        const url = URL_SERVICIOS_LOCALES;
        return this.http.post(`${url}/query`, data);
     }
  }
}



// WEBPACK FOOTER //
// ./src/providers/entidades/entidades.ts